import axios from 'axios';
import { authHeader } from './authservice/auth-header';

const API_URL = process.env.VUE_APP_BASE_API_URL;

class GrupService {
    listGrup() {
        return axios.get(API_URL+'group/list', { headers: authHeader() });
    }

    addGrup(data) {
        return axios.post(API_URL+'group/add', data, { headers: authHeader() });
    }

    editGrup(data) {
        return axios.post(API_URL+'group/add', data, { headers: authHeader() });
    }

    detailGrup(data) {
        return axios.post(API_URL+'group/detail', data, { headers: authHeader() });
    }

    deleteGrup(data) {
        return axios.post(API_URL+'group/delete', data, { headers: authHeader() });
    }

    listGrupMember(data) {
        return axios.post(API_URL+'group/detail', data, { headers: authHeader() });
    }

    editMember(data) {
        return axios.post(API_URL+'group/editMember', data, { headers: authHeader() });
    }


}

export default new GrupService();
